import { render, staticRenderFns } from "./StaticPageEditor.vue?vue&type=template&id=27bca48b&scoped=true&"
import script from "./StaticPageEditor.vue?vue&type=script&lang=js&"
export * from "./StaticPageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bca48b",
  null
  
)

export default component.exports